import { useFetchState } from "@hooks/useFetchState";
import { getIsBroadbandEmailSent, getProspectReference, saveBroadbandEmailSent } from "@utils/storage";
import { useForm } from "react-hook-form";
import { postSaveEmail } from "@modules/eirSalesFacade/apis/saveEmail";
import { IEirSalesSaveEmailPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSaveEmailPayload";
import { mapEirSalesSaveEmailPayload } from "@modules/eirSalesFacade/mappers/mapEirSalesSaveEmailPayload";
import { IEmailForm } from "./IEmail";
import { useState } from "react";

interface IParams {
    eircode: string;
    persistBroadbandEmailSent?: boolean;
}

export const useEmail = (props: IParams) => {
    const { eircode, persistBroadbandEmailSent } = props;
    const formMethods = useForm<IEmailForm>({ defaultValues: { email: "" } });
    const { startFetching, endFetching, error, isLoading } = useFetchState();
    const [isEmailSentSucceed, setIsEmailSentSucceed] = useState(
        persistBroadbandEmailSent ? getIsBroadbandEmailSent() : false
    );
    const prospectReference = getProspectReference();

    const submitEmail = formMethods.handleSubmit(async (formData: IEmailForm) => {
        if (!prospectReference) {
            return;
        }

        try {
            startFetching();

            const payload: IEirSalesSaveEmailPayload = mapEirSalesSaveEmailPayload(formData.email, eircode);
            await postSaveEmail(prospectReference, payload);

            endFetching();
            setIsEmailSentSucceed(true);

            if (persistBroadbandEmailSent) {
                saveBroadbandEmailSent();
            }
        } catch (apiError) {
            endFetching(apiError);
        }
    });

    return {
        formMethods,
        error,
        isLoading,
        isEmailSentSucceed,
        submitEmail,
    };
};
